<template>
    <div class="row">
        <div v-bind:class="responsiveClasses.changeStatusSelectCol">
            <pc-select
                id="ChangePaymentStatusSelect"
                v-model="newStatus"
                v-bind:options="allowedStatuses"
                label="Change payment status to:">
                <option value="">Select payment status...</option>
            </pc-select>
        </div>
        <div class="col d-flex align-items-end justify-content-end">
            <pc-button
                id="ChangePaymentStatusCancel"
                class="me-2"
                v-on:click="changeStatusCancel">
                Cancel
            </pc-button>
            <pc-button
                id="ChangePaymentStatusSave"
                v-bind:disabled="!newStatusSelected"
                primary
                v-on:click="changeStatusOk">
                Save
            </pc-button>
        </div>
    </div>
</template>
<script>
    import { getResponsiveClassMap } from "Responsive/manager";

    const responsiveConfig = {
        changeStatusSelectCol: {
            col: { xs: 12, sm: 6 },
            mb: { xs: 2, sm: 0 }
        }
    };

    export default {
        inject: {
            viewport: {
                from: "viewport",
                default: null
            }
        },
        props: {
            charge: { type: Object, required: true },
            currentPaymentProvider: { type: Number, required: true },
            adapterOptions: { type: Object, required: false, default: null }
        },
        emits: ["change-status-cancel", "edit-status"],
        data() {
            return {
                newStatus: null
            };
        },
        computed: {
            statusTransitions() {
                if (!this.adapterOptions.StatusTransitionList) {
                    return [];
                }

                const transitionsForThisStatus = this.adapterOptions.StatusTransitionList.find((transitionList) => {
                    return transitionList.EditableStatus === this.charge.Status;
                });

                return (transitionsForThisStatus && transitionsForThisStatus.AllowedTargetStatuses) || [];
            },
            isFromCurrentPaymentProvider() {
                return this.charge && this.charge.PaymentProviderId === this.currentPaymentProvider;
            },
            nameOverrides() {
                if (this.isFromCurrentPaymentProvider) {
                    return this.adapterOptions && this.adapterOptions.StatusNameOverrides;
                }
                return {};
            },
            allowedStatuses() {
                const statusOptions = this.statusTransitions.map((st) => {
                    return {
                        text: st.DisplayName,
                        value: st.TargetStatus
                    };
                });

                return statusOptions;
            },
            newStatusSelected() {
                return Boolean(this.newStatus);
            },
            responsiveClasses() {
                return getResponsiveClassMap(this.viewport, responsiveConfig);
            }
        },
        methods: {
            changeStatusCancel() {
                this.$emit("change-status-cancel");
            },
            changeStatusOk() {
                this.$emit("edit-status", this.charge.ChargeId, this.newStatus);
            }
        }
    };
</script>
